import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';
import { useState, useCallback, useEffect } from "react";
import ImageViewer from "react-simple-image-viewer";

import img1 from "src/assets/images/gallery/1.webp";
import img2 from "src/assets/images/gallery/2.webp";
import img3 from "src/assets/images/gallery/3.webp";
import img4 from "src/assets/images/gallery/4.webp";
import img5 from "src/assets/images/gallery/5.webp";
import img6 from "src/assets/images/gallery/6.webp";
import img7 from "src/assets/images/gallery/7.webp";
import img8 from "src/assets/images/gallery/8.webp";
import img9 from "src/assets/images/gallery/9.webp";
import img10 from "src/assets/images/gallery/10.webp";
import img11 from "src/assets/images/gallery/11.webp";
import img12 from "src/assets/images/gallery/12.webp";



import { isRTL } from 'src/utils/global';
import { Title } from 'src/components';

const images: string[] = [
    img1, img2, img3, img4, img5, img6,
    img7, img8, img9, img10, img11, img12
];


const Gallery = () => {
    const { t } = useTranslation("home");
    const [currentImage, setCurrentImage] = useState<number>(0);
    const [isViewerOpen, setIsViewerOpen] = useState<boolean>(false);

    const openImageViewer = useCallback((index: number) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
        toggleBodyScroll(true); // Disable scroll
    }, []);

    const closeImageViewer = useCallback(() => {
        setCurrentImage(0);
        setIsViewerOpen(false);
        toggleBodyScroll(false); // Enable scroll
    }, []);


    const toggleBodyScroll = (disable: boolean) => {
        if (disable) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
    };
    useEffect(() => {
        return () => {
            toggleBodyScroll(false); // Ensure scroll is re-enabled on unmount
        };
    }, []);

    return (
        <section className={`${styles.gallery} ${isRTL() && styles.rtl}`}>
            <div className={styles.overlay}></div>
            <div className={styles.overlay_extra}></div>
            <div className='container'>
                <Title lgTitle={t("gallery.title")} />
                <p className={styles.overview}>
                    {t("gallery.text")}
                    <div className={styles.under_line}></div>
                </p>

                <div className={styles.imgs__con}>
                    <div className="row">
                        {images.map((image, index) => (
                            <div
                                key={`gallery_img_${index}`}
                                className="col-12 col-md-6 col-lg-4">
                                <div onClick={() => openImageViewer(index)}
                                    className={styles.img__con}>
                                    <img
                                        src={image}
                                        className={styles.img}
                                        alt={`Tarsin Al Oula ${index}`}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    {isViewerOpen && (
                        <ImageViewer
                            src={images}
                            backgroundStyle={{ zIndex: 99999 }}
                            currentIndex={currentImage}
                            onClose={closeImageViewer}

                        />


                    )}
                </div>
            </div>
        </section>
    )
}

export default Gallery;



